import { useTranslation } from 'next-i18next'

export default function PluginClearFilter ({ callback }) {
  const { t } = useTranslation(['plugins'])

  return (
    <button
      className="col-auto btn-sm btn btn-outline-primary w-100 mt-2"
      onClick={() => callback()}
    >
      {t('browse_all.filter.clear')}
      <svg
        viewBox="-0.19999999999999996 -0.19999999999999996 10.4 10.4"
        xmlns="http://www.w3.org/2000/svg"
        height="8"
        width="8"
        strokeWidth="1.4"
        className="ms-2"
      >
        <path
          d="M9.5 0.5L0.5 9.5"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M0.5 0.5L9.5 9.5"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </svg>
    </button>
  )
}
